var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help"},[_c('p',[_vm._v("Напишите, что вы хотите улучшить или добавить, предложите свои идеи.")]),_c('p',[_vm._v("Написать в службу поддержки.")]),_c('br'),_c('mts-button',{attrs:{"theme":"dark"},on:{"click":_vm.onClick}},[_vm._v("Написать")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }